// @ constants
const actionTypes = require('constants/actionTypes');

const reset = () => ({
    type: actionTypes.HIRE_CONTACT_DATA_RESET,
});

const createInstance = (instanceId) => ({
    type: actionTypes.HIRE_CONTACT_DATA_CREATE_INSTANCE,
    payload: {
        instanceId
    }
});

const validateStep = (hasMobileField = true, instanceId) => ({
    type: actionTypes.HIRE_CONTACT_DATA_VALIDATE_STEP,
    payload: {
        instanceId,
        hasMobileField
    }
});

const validateField = (fieldName, instanceId) => ({
    type: actionTypes.HIRE_CONTACT_DATA_VALIDATE_FIELD,
    payload: {
        fieldName,
        instanceId
    }
});

const fillOpenYoungProfile = (immOpenYoungProfile, instanceId) => ({
    type: actionTypes.HIRE_CONTACT_DATA_FILL_OPEN_YOUNG_PROFILE,
    payload: {
        immOpenYoungProfile,
        instanceId
    }
});

const fillProfileShippingAddress = (immProfileShippingAddress) => ({
    type: actionTypes.HIRE_CONTACT_DATA_FILL_SHIPPING_ADDRESS_PROFILE,
    payload: {
        immProfileShippingAddress,
    }
});

const fillProfile = (immProfile, instanceId) => ({
    type: actionTypes.HIRE_CONTACT_DATA_FILL_PROFILE,
    payload: {
        immProfile,
        instanceId
    }
});

const loadUserData = (instanceId) => (dispatch, getState) => dispatch(fillProfile(getState().profile, instanceId));

const setField = (field, value, instanceId) => ({
    type: actionTypes.HIRE_CONTACT_DATA_SET_FIELD,
    payload: {
        field,
        instanceId,
        value
    }
});

const setOriginCountry = (originCountry) => ({
    type: actionTypes.HIRE_CONTACT_DATA_SET_ORIGIN_COUNTRY,
    payload: {
        originCountry
    }
});

const setupInitialData = (prepopulate, instanceId, originCountry)  => (dispatch, getState) => {
    let immHireContactData = getState().hireContactData;
    dispatch(setOriginCountry(originCountry))

    if (instanceId) {
        if (!immHireContactData.hasIn(['extraInstances',instanceId])) {
            dispatch(createInstance(instanceId));
        }
        immHireContactData = getState().hireContactData.getIn(['extraInstances',instanceId]);
    }

    if (prepopulate && !immHireContactData.get('isDirty')) {
        dispatch(loadUserData(instanceId));
    }
}


module.exports = {
    createInstance,
    fillProfile,
    fillOpenYoungProfile,
    fillProfileShippingAddress,
    loadUserData,
    reset,
    setField,
    setupInitialData,
    validateField,
    validateStep,
};
